import React, { useState, useEffect, Fragment, useRef } from 'react';
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import {
    Persona, PersonaSize, PrimaryButton, DefaultButton, GroupHeader, DetailsList, NormalPeoplePicker, CheckboxVisibility, Checkbox, Spinner, SpinnerSize
} from '@fluentui/react';
import _ from "lodash"
import { shallowEqual, useSelector } from 'react-redux';

function AnnouncementDetails(props) {
    const [items, setItems] = React.useState([]);
    const [groups, setGroups] = React.useState([]);
    const columns = [
        {
            key: 'more',
            name: '',
            fieldName: 'userId',
            onRender: (item) => {
                return buildRow(item)
            }
        },
    ];

    const buildRow = (item) => {
        return <div className="displayflex flex1 aligncenter" style={{ justifyContent: 'space-between' }}>
            <div className="displayflex flex1" >
                <Persona
                    key={item.userId}
                    imageUrl={item.profileImage ? process.env.REACT_APP_CDN_URL + item.profileImage : null}
                    imageInitials={item.imageInitials}
                    text={item.text}
                    initialsColor={item.initialsColor}
                    size={PersonaSize.size24}
                />
            </div>
        </div>
    }
    const {employees } = useSelector(state => ({
        employees: state.appState.product.facility.employees
    }));

    useEffect(() => {
        
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetAnnouncementDetails?id=" + props.id)
            .then((response) => {
                
                var items = [];
                response.data.forEach((user, index) => {
                    var element = employees.filter(item => item.userId == user.userId)[0];
                    const item = {
                        role: element.role,
                        checked: false,
                        userId: element.userId,
                        roleId: element.roleId ? element.roleId.toString() : "",
                        key: element.userId.toString(),
                        imageInitials: element.firstName.substring(0, 1) + element.lastName.substring(0, 1),
                        initialsColor: element.avatarColor,
                        text: element.firstName + ' ' + element.lastName,
                        profileImage: element.profileImage,
                        type: 'employee',
                        seen: user.seen ? "Seen" : "Not seen"
                    };
                    items.push(item);
                });
                setGroups(groupsGenerator(items, "seen"))
                setItems(items)
            });
    }, []);

    const groupsGenerator = (itemsList, fieldName) => {
        if (fieldName == 'ungroup') {
            return null;
        }
        if (!itemsList) {
            return []
        }
        // Array of group objects
        const groupObjArr = []

        // Get the group names from the items list
        const groupNames = [...new Set(itemsList.map(item => item[fieldName]))]

        // Iterate through each group name to build proper group object
        groupNames.forEach(gn => {
            // Count group items
            const groupLength = itemsList.filter(item => item[fieldName] === gn).length

            // Find the first group index
            const groupIndex = itemsList.map(item => item[fieldName]).indexOf(gn)

            // Generate a group object
            groupObjArr.push({
                key: gn, name: gn, level: 0, count: groupLength, startIndex: groupIndex, isCollapsed: true
            })
        })
        return groupObjArr
    }


    return (
        <div className={`chat-list ${props.bot ? 'px20' : ''}`}>

            <div className="displayflex flexcolumn width100 border-bottom" style={{ padding: '15px 20px 10px 0' }} >

                <h5 className="head-xs" style={{ fontSize: 13 }} >{items.length} Team Members</h5>

            </div>
            <div className="custom-scrollbar height100 employee-picker" style={{ padding: '0 0px', height:'calc(100vh - 150px)' }}>
                {props.group && <DetailsList
                    selectionPreservedOnEmptyClick={false}
                    items={items}
                    checkboxVisibility={CheckboxVisibility.hidden}

                    groups={groups}
                    columns={columns}
                    isHeaderVisible={false}
                />}
                {!props.group && <DetailsList
                    selectionPreservedOnEmptyClick={false}
                    items={items}
                    checkboxVisibility={CheckboxVisibility.hidden}

                    columns={columns}
                    isHeaderVisible={false}
                />}
            </div>

        </div>
    );

}

export default AnnouncementDetails;

